import '../Styles/dashboardStyle.css';
import { getAuth, signOut } from "firebase/auth";
import { auth } from '../firebase';
import react, { useState, useEffect } from 'react';
import { Outlet, Link, Route, Routes, useNavigate } from 'react-router-dom';
import Home from './Home';
import AuctionsPage from './Auction/AuctionsPage';
import Profile from './Profile';
import AboutUs from './AboutUs';
import HowItWorks from './HowItWorks';
import CreateAuctionItem from './Auction/CreateAuctionItem';
import AuctionItemView from './Auction/AuctionItemView';
import Offices from './Offices';
import { FacebookIcon, InstagramIcon, LinkedInIcon, TikTokIcon, YoutubeIcon } from './Utils/Icons';

function Dashboard() {
    const [menuVisible, setMenuVisible] = useState(false); 
    const [activeTab, setActiveTab] = useState('HomeTab');
    const [previousTab, setPreviousTab] = useState(null);
    const [apiExpanded, setApiExpanded] = useState(false);
    const [user, setUser] = useState(null);

    const auth = getAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((currentUser) => {
            setUser(currentUser);
        });
  
        return () => unsubscribe();
    }, [auth, navigate]);

    const handleSignOut = () => {
        localStorage.clear();
        sessionStorage.clear();

        signOut(auth)
            .then(() => {
                navigate('/login'); // Navigate to login page after sign out
            })
            .catch((error) => {
                console.log(error.message);
            });
    }

    const toggleMenu = () => {
        setMenuVisible((prev) => !prev);
    };

    return (
        <div className="dashboard">
            <div className="dashContainer">
                <div className="Nav">
                    <button className="hamburger" onClick={toggleMenu}>
                        ☰
                    </button>
                    <div className={`sideBtns ${menuVisible ? 'visible' : 'hidden'}`}>
                        <Link to="/home" className='navLink' style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                            <div className="BCAIcon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-opacity="0" stroke="currentColor" stroke-dasharray="64" stroke-dashoffset="64" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12c0 -4.97 4.03 -9 9 -9c4.97 0 9 4.03 9 9c0 4.97 -4.03 9 -9 9c-4.97 0 -9 -4.03 -9 -9Z"><animate fill="freeze" attributeName="fill-opacity" begin="0.6s" dur="0.15s" values="0;0.3"/><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="64;0"/></path></svg>
                                <h2>Big Circle Auctions</h2>
                            </div>
                        </Link>

                        <div className="hor-flex">
                            <Link to="/auctions" className='navLink' style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="m12 14.006l-6.156 7.227a2.182 2.182 0 1 1-3.077-3.077L9.994 12M22 11.905L15.905 18m-3.81-16L6 8.095m5.333-5.333L6.762 7.333s2.286 3.048 4.571 5.334c2.286 2.285 5.334 4.571 5.334 4.571l4.571-4.571s-2.286-3.048-4.571-5.334c-2.286-2.285-5.334-4.571-5.334-4.571" color="currentColor"/>
                                </svg> */}
                                Auctions
                            </Link>

                            {user ? (
                                <Link to="/profile" className='navLink' style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <g fill="none"><path stroke="currentColor" d="M21 12a8.96 8.96 0 0 1-1.526 5.016A8.99 8.99 0 0 1 12 21a8.99 8.99 0 0 1-7.474-3.984A9 9 0 1 1 21 12Z"/><path fill="currentColor" d="M13.5 9a1.5 1.5 0 0 1-1.5 1.5v1A2.5 2.5 0 0 0 14.5 9zM12 10.5A1.5 1.5 0 0 1 10.5 9h-1a2.5 2.5 0 0 0 2.5 2.5zM10.5 9A1.5 1.5 0 0 1 12 7.5v-1A2.5 2.5 0 0 0 9.5 9zM12 7.5A1.5 1.5 0 0 1 13.5 9h1A2.5 2.5 0 0 0 12 6.5zM5.166 17.856l-.48-.142l-.077.261l.177.207zm13.668 0l.38.326l.177-.207l-.078-.261zM9 15.5h6v-1H9zm0-1a4.5 4.5 0 0 0-4.313 3.214l.958.285A3.5 3.5 0 0 1 9 15.5zm3 6a8.48 8.48 0 0 1-6.455-2.97l-.759.652A9.48 9.48 0 0 0 12 21.5zm3-5a3.5 3.5 0 0 1 3.355 2.5l.958-.286A4.5 4.5 0 0 0 15 14.5zm3.455 2.03A8.48 8.48 0 0 1 12 20.5v1a9.48 9.48 0 0 0 7.214-3.318z"/></g>
                                    </svg> */}
                                    Profile
                                </Link>
                            ) : (
                                <p></p>
                            )}

                            <Link to="/contact" className='navLink' style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                                Contact Us
                            </Link>
                        </div>

                        {user ? (
                            <button className="logoutBtn" onClick={handleSignOut}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path fill="currentColor" d="M4 20V4h8.02v1H5v14h7.02v1zm12.462-4.461l-.702-.72l2.319-2.319H9.192v-1h8.887l-2.32-2.32l.702-.718L20 12z"/>
                                </svg>
                                Logout
                            </button>
                        ): (
                            <button className="logoutBtn" onClick={handleSignOut}>
                                Login
                            </button>
                        )}
                        
                    </div>
                </div>

                <div className="tabs">
                    <Outlet />
                </div>

                <footer>
                    <div className="upper">
                        <div className="links">
                            <h3>Quick Links</h3>
                            <Link to="/how-it-works" className='navLink' style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path fill="currentColor" d="M11.5 16.5h1V11h-1zm.5-6.923q.262 0 .439-.177t.176-.439t-.177-.438T12 8.346t-.438.177t-.177.439t.177.438t.438.177M12.003 21q-1.867 0-3.51-.708q-1.643-.709-2.859-1.924t-1.925-2.856T3 12.003t.709-3.51Q4.417 6.85 5.63 5.634t2.857-1.925T11.997 3t3.51.709q1.643.708 2.859 1.922t1.925 2.857t.709 3.509t-.708 3.51t-1.924 2.859t-2.856 1.925t-3.509.709M12 20q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"/>
                                </svg> */}
                                Additional Information
                            </Link>

                            <Link to="/about-us" className='navLink' style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                    <path fill="currentColor" d="M8.923 5.33a3.5 3.5 0 0 1 6.154 0a2.643 2.643 0 1 1-.1 3.512A3.5 3.5 0 0 1 12 10.5a3.5 3.5 0 0 1-2.976-1.657a2.643 2.643 0 1 1-.1-3.513m.633 1.14a2.65 2.65 0 0 1 .035 1.199a2.501 2.501 0 0 0 4.819 0a2.66 2.66 0 0 1 .034-1.2a2.501 2.501 0 0 0-4.888 0m-1.026.072a1.643 1.643 0 1 0 .031 1.114a3.5 3.5 0 0 1-.031-1.114m6.909 1.113a1.644 1.644 0 1 0 .031-1.113a3.5 3.5 0 0 1-.031 1.113M4.951 10.297c.347-.092.675.022.901.186c.09.065.214.145.365.218a.5.5 0 0 1-.435.9a3.4 3.4 0 0 1-.517-.308a.2.2 0 0 0-.053-.027l-.007-.001a7 7 0 0 0-.401.12l-.686.224a1.63 1.63 0 0 0-1.066 1.114l-.283 2.049c-.056.403.157.705.46.777q.335.082.813.16a.5.5 0 1 1-.16.988a12 12 0 0 1-.884-.175c-.895-.213-1.333-1.07-1.22-1.887l.292-2.106l.006-.027a2.62 2.62 0 0 1 1.73-1.843l.685-.225q.23-.075.46-.137m14.229 0a1.07 1.07 0 0 0-.9.186c-.09.065-.214.145-.365.218a.5.5 0 0 0 .435.9a3.4 3.4 0 0 0 .517-.308a.2.2 0 0 1 .053-.027l.005-.001h.002q.203.053.401.12l.686.224c.526.173.925.594 1.066 1.114l.283 2.049c.056.403-.156.705-.46.777a11 11 0 0 1-.813.16a.5.5 0 1 0 .16.988q.512-.085.884-.175c.895-.213 1.333-1.07 1.22-1.887l-.292-2.106l-.006-.027a2.62 2.62 0 0 0-1.73-1.843l-.685-.225a9 9 0 0 0-.46-.137"/><path fill="currentColor" d="M13.791 11.92c.359-.238.86-.41 1.377-.265q.234.066.467.143l.959.315a3.47 3.47 0 0 1 2.29 2.44l.007.027l.406 2.936c.147 1.06-.42 2.15-1.554 2.42c-1.15.274-3.012.564-5.743.564c-2.73 0-4.593-.29-5.743-.564c-1.134-.27-1.701-1.36-1.554-2.42l.406-2.936l.007-.027a3.47 3.47 0 0 1 2.29-2.44l.96-.315q.232-.077.466-.143c.517-.146 1.018.027 1.377.265c.383.254 1.013.566 1.791.566s1.409-.312 1.791-.566m1.105.697c-.142-.04-.34-.004-.552.136c-.477.317-1.3.733-2.344.733s-1.867-.416-2.344-.733c-.211-.14-.41-.176-.552-.136q-.215.06-.426.13l-.96.316a2.48 2.48 0 0 0-1.626 1.71l-.399 2.88c-.09.647.253 1.18.796 1.31c1.067.255 2.852.537 5.511.537s4.444-.282 5.511-.537c.543-.13.885-.663.796-1.31l-.399-2.88a2.48 2.48 0 0 0-1.626-1.71l-.96-.315q-.211-.07-.426-.13"/>
                                </svg> */}
                                About Us
                            </Link>

                            <Link to="/offices" className='navLink' style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                                {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 256 256">
                                    <path fill="currentColor" d="M248 210h-18V94h2a6 6 0 0 0 0-12h-50V46h2a6 6 0 0 0 0-12H40a6 6 0 0 0 0 12h2v164H24a6 6 0 0 0 0 12h224a6 6 0 0 0 0-12M218 94v116h-36V94ZM54 46h116v164h-28v-50a6 6 0 0 0-6-6H88a6 6 0 0 0-6 6v50H54Zm76 164H94v-44h36ZM74 80a6 6 0 0 1 6-6h16a6 6 0 0 1 0 12H80a6 6 0 0 1-6-6m48 0a6 6 0 0 1 6-6h16a6 6 0 0 1 0 12h-16a6 6 0 0 1-6-6m-42 46a6 6 0 0 1 0-12h16a6 6 0 0 1 0 12Zm42-6a6 6 0 0 1 6-6h16a6 6 0 0 1 0 12h-16a6 6 0 0 1-6-6"/>
                                </svg> */}
                                Offices
                            </Link>

                            <Link to="/contact" className='navLink' style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                                Contact Us
                            </Link>
                        </div>
                        <div className="links">
                            <h3>Important Info</h3>
                            <Link to="/eula" className='navLink' style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                                    End User License Agreement
                            </Link>
                            <Link to="/terms-conditions" className='navLink' style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                                Terms & Conditions
                            </Link>
                            <Link to="/seller-terms-conditions" className="navLink" style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                                Seller Terms & Conditions
                            </Link>
                            <Link to="/privacy-policy" className="navLink" style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                                Privacy Policy
                            </Link>
                            {/* <Link to="/refund-policy" className="navLink" style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                                Refund Policy
                            </Link> */}
                            <Link to="/prohibited" className='navLink' style={{ textDecoration: 'none' }} onClick={() => setMenuVisible(false)}>
                                Prohibited Auction Items
                            </Link>
                        </div>
                        <div className="contact">
                            <h3>BCA</h3>
                            <p>414 S Main Street #201 • Rochester, MI 48307</p>
                            <p>contact@bigcircleauctions.com</p>
                            <p>855-2WINBCA (855-294-6222)</p>
                        </div>
                    </div>
                    <div className="copyright">
                        <p>
                            © 2025 Big Circle Auctions. All Rights Reserved.
                        </p>
                        <div className="socials">
                            <a href="https://www.linkedin.com/company/big-circle-auctions/" target="_blank">
                                <LinkedInIcon />
                            </a>
                            <a href="https://www.facebook.com/profile.php?id=61576282700250" target="_blank">
                                <FacebookIcon />
                            </a>
                            <a href="https://www.instagram.com/bigcircleauctions/" target="_blank">
                                <InstagramIcon />
                            </a>
                            <a href="https://www.tiktok.com/@bigcircleauctions" target="_blank">
                                <TikTokIcon />
                            </a>
                            <a href="https://www.youtube.com/@BigCircleAuctions" target="_blank">
                                <YoutubeIcon />
                            </a>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    )
}

export default Dashboard;